/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  quarterToDate,
  convertStringDate,
  compareDate,
  validateDateQuarter,
} from '../../../../SharedModules/utilities/dateUtilities';
import {
  monthMapping,
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getInterestOverrideReports,
  setInterestOverrideReport,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import {
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  FROM_DATE_QTR_REQUIRED,
  FROM_DATE_REQUIRED,
  INVALID_DATE_DURATION,
  REBATE_SELECT,
  TO_DATE_QTR_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import moment from 'moment';

const InterestOverrideRequest = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    fromDateValue,
    toDateValue,
    searchResult,
  } = useSelector((state) => state?.sharedState?.InterestOverrideReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [selectList, setSelectList] = React.useState([]);

  const [planType, setPlanType] = React.useState(selectedPlanType);

  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);

  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);

  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  const [errorList, setErrorList] = React.useState(errors);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList?.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
    handleScrollToEvent();
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/interestOverride', true);
    } else {
      tabHighLigther('/interestOverride', false);
    }
  }, [JSON.stringify(errorList)]);
    
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [toDate, fromDate, rebateProgram, selectList]);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
      dispatch(setSearchInput({ errors: [] }));
    const value = autoFormateDate(input.toUpperCase());
    let allErrors = errorList;
    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      if (!value)
        fromError = [{ field: 'fromDate', message: FROM_DATE_QTR_REQUIRED }];
      else if (validateDateQuarter(value, 'fromDate')?.length)
        fromError = validateDateQuarter(value, 'fromDate');
      allErrors = [...allErrors, ...fromError];
      if (!toDate && !fromError.length) setToDate(value.toUpperCase());
    }
    fromError = allErrors.filter((item) => item.field === 'fromDate');
    if (type === 'toDate') {
      if (!value)
        toError = [{ field: 'toDate', message: TO_DATE_QTR_REQUIRED }];
      setToDate(value.toUpperCase());
      if (value.trim().length > 0)
        toError = validateDateQuarter(value, 'toDate');

      allErrors = [...allErrors, ...toError];
    }
    if (value.trim().length > 0) {
      toError = allErrors.filter((item) => item.field === 'toDate');
    }

    if (fromError.length === 0 && toError.length === 0) {
      allErrors = allErrors.filter(
        (error) =>
          error.field !== 'toDate' &&
          // error.field !== 'fromDate' &&
          error.field !== 'fromDate>toDate'
      );
      let frmDt, toDt;
      if (type === 'fromDate' && value) frmDt = value;
      else frmDt = fromDate;
      if (type === 'toDate' && value) toDt = value;
      else toDt = toDate;
      if (compareDate(frmDt, toDt)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT.replace(
            'End Date',
            'To Date/Quarter'
          ).replace('Start Date', 'From Date/Quarter'),
        });
      } else if (moment(toDate).diff(moment(fromDate), 'years') > 0) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: INVALID_DATE_DURATION,
        });
      }
    }
    setErrorList(allErrors);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen

  /* istanbul ignore next */
  const handleSearchClick = () => {
    dispatch(setSearchInput({ errors: [] }));
    let allErrors = errorList;
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    const fromError = validateDateQuarter(fromDate, 'fromDate');
    const toError = validateDateQuarter(toDate, 'toDate');
    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        toDateValue: toDate,
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgrameName,
        displayObj: {
          rebateProgramValue: rebateProgram,
          fromDateValue: fromDate,
          toDateValue: toDate,
          rebateProgrameName,
        },
      })
    );

    let beginDate = quarterToDate(fromDate);
    let endDate = quarterToDate(toDate, 'toDate') || quarterToDate(fromDate);
    if (beginDate.includes('/')) {
      const splittedBD = beginDate.split('/');
      beginDate = `${splittedBD[0]}-${monthMapping[splittedBD[0]]}-${
        splittedBD[2]
      }`;
    }
    if (endDate.includes('/')) {
      const splittedED = endDate.split('/');
      endDate = `${splittedED[0]}-${monthMapping[splittedED[0]]}-${
        splittedED[2]
      }`;
    }

    if (allErrors.length === 0) {
      dispatch(setInterestOverrideReport([]));
      setSearchClicked(true);
      dispatch(
        getInterestOverrideReports({
          asRpc: rebateProgram,
          adBegin: beginDate,
          adEnd: endDate,
        })
      );
    }
  };
  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/interestOverrideDetail',

      value: 'Interest Override Display',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props.history.push({
      pathname: '/interestOverrideDetail',
    });
    dispatch(clearReduxForFilterAndSort('/interestOverrideDetail'));
  }
  const updatedErrorList = errorList.map((item) => {
    return {
      ...item,
      message: item.message
        .replace('From date', 'Begin date')
        .replace('To date', 'End date')
        .replace('Start Date', 'Begin Date'),
    };
  });
  const errorMessages = [
    ...new Set(updatedErrorList.map((obj) => obj.message)),
  ];

  return (
    <div className='tabs-container'>
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1='Detail Reports'
        parent2='Interest Override Request'
      />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

      <div className='tab-body' />
      <div className='row'>
        <div className='col-4 frr-two-col-radio'>
          <RadioGroupComponent
            data-testid='Interest-override-plan-type'
            id='filter-plan-by-radio-btn-action'
            labelName='Plan Type'
            required
            optionList={radioList || []}
            defaultValue={planType}
            filterAction={(value) => {
              setPlanType(value);
              setRebateProgram('-1');
              const errors = errorList.filter(
                (error) => error.field !== 'rebateProgram'
              );
              setErrorList([...errors]);
            }}
            className='log-batch-filter-radio frr-checkInvoiceRadio'
          />
        </div>
        <div className='col-4'>
          <>
            <Fieldset label='Rebate Program' required>
              <div style={{ marginTop: 18 }}>
                <SelectBoxComponent
                  data-testid='Interest-override-rebate-program'
                  id='filter-plan-by-radio-btn-action'
                  labelName='Rebate Program'
                  required
                  select
                  selectOne
                  optionList={selectList || []}
                  defaultValue={rebateProgram}
                  filterAction={(value) => {
                    setRebateProgram(value);
                    setRebateProgramName(value);
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  isError={
                    errorList.find((error) => error.field === 'rebateProgram')
                      ?.message
                  }
                />
              </div>
            </Fieldset>
          </>
        </div>
        <div className='col-4'>
          <Fieldset label='Date/Quarter Range' required>
            <div className='form-wrapper p-0 mt-n3'>
              <div className='mui-custom-form input-md field-xl'>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label='From Date/Quarter'
                      id='From Date'
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10, 'aria-describedby': '' }}
                      name='From'
                      value={fromDate}
                      error={updatedErrorList?.some(
                        (error) => error.field === 'fromDate'
                      )}
                      data-testid='interest-override-from-date'
                      helperText={
                        updatedErrorList.find(
                          (error) => error.field === 'fromDate'
                        )?.message
                      }
                      className='mandate-fields'
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label='To Date/Quarter'
                      id='To Date'
                      data-testid='interest-override-to-date'
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10, 'aria-describedby': '' }}
                      name='to'
                      value={toDate}
                      onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                      onChange={(e) => {
                        setToDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) =>
                              error.field !== 'toDate' &&
                              error.field !== 'fromDate>toDate'
                          ),
                        ]);
                      }}
                      error={
                        updatedErrorList.filter(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.length > 0
                          ? true
                          : false
                      }
                      helperText={
                        updatedErrorList.find(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.message
                      }
                      className='mandate-fields'
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className='row' style={{ marginTop: 30 }}>
        <div className='btn-wrapper col-12' tabIndex={0}>
          <Button
            data-testid='interest-override-search-btn'
            onClick={handleSearchClick}
            className='btn btn-success btn-search float-right'
          >
            <SVGComponent iconName='Icon-search' /> Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InterestOverrideRequest;
